import BaseComponent from '../abstracts/BaseComponent';
import { removeMarkers } from '../utilities/Spring';

const debug = false;

export default class ListFilter extends BaseComponent {

  constructor(element) {
    super(element);

    debug && console.log('ListFilter');

    removeMarkers(this.$el);

    this.initElement();

    this.GRAB(this.CUSTOM_MESSAGES.MODAL_EVENTS.afterOpen, this.onModal);

    const query = new URLSearchParams(new FormData(this.$el.querySelector('form'))).toString();
    debug && console.log('query', query);

    // PITTI20-1464
    setTimeout(() => this.EMIT(this.CUSTOM_MESSAGES.NEWS_LIST_EVENTS.init, {
      container: this.$el,
      query
    }), 200);
  }

  get SEARCH_SELECTOR() {
    return this.$options.searchSelector;
  }

  get SEARCH_ICON() {
    return this.$options.searchIcon;
  }

  initElement = element => {
    (element || this.$el).querySelectorAll('[data-apply-filter]').forEach(item => {
      item.addEventListener('click', this.applyFilter);
    });
    const searchInput = this.$el.querySelector(this.SEARCH_SELECTOR);
    searchInput && searchInput.addEventListener('keyup', this.onKeyup);
  }

  onModal = event => {
    const element = event.vexInstance.contentEl;
    if (!element.classList.contains('news-filters')) {
      return;
    }
    this.initElement(element);
  }

  applyFilter = async event => {
    debug && console.log('ListFilter applyFilter');

    // PITTI20-932
    const currentTarget = event.currentTarget;
    const form = currentTarget.closest('form');
    const applyButton = form.querySelector('#apply-filters');
    const applyClicked = applyButton && applyButton.isSameNode(currentTarget);
    const ignoreClick = !applyClicked && applyButton && applyButton.offsetParent;
    debug && console.log('ListFilter applyFilter ignoreClick', ignoreClick);
    if (ignoreClick) {
      return;
    }
    if (applyClicked) {
      this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.close);
    }

    const query = new URLSearchParams(new FormData(form)).toString().replace(/__layer=/g, '=');
    debug && console.log('query', query);

    this.EMIT(this.CUSTOM_MESSAGES.NEWS_LIST_EVENTS.filter, {
      container: this.$el,
      query
    });

    /* PITTI20-1252
    if (this.$el.querySelector('.dropdown-filter')) {
      return;
    }
    */

    debug && console.log('wait for filter');
    let text = await this.filter(query);
    debug && console.log('fulfilled filter');

    this.update(text);
  }

  onKeyup = event => {
    debug && console.log('ListFilter onKeyup');

    if (event.keyCode === 13) {
      event.preventDefault();
      const searchIcon = this.$el.querySelector(this.SEARCH_ICON);
      if (searchIcon) {
        searchIcon.click();
      }
    }
  }

  filter(query) {
    debug && console.log('ListFilter filter query', query);

    return new Promise(resolve => {
      fetch(`${location.pathname}?filter=true${query ? `&${query}` : ''}`, {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          Accept: 'text/html'
        }
      }).then(response => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Not 200 response');
        }
      }).then(text => {
        resolve(text);
      }).catch(function(err) {
        debug && console.log('ListFilter items err', err);
      });
    });
  }

  update = text => {
    debug && console.log('ListFilter update text', text);

    // PITTI20-943
    const panels = this.$el.querySelectorAll('.dropdown-panel');
    if (panels.length) {
      const div = document.createElement('div');
      div.innerHTML = text;
      div.querySelectorAll('.dropdown-panel').forEach((panel, index) => {
        panels[index].innerHTML = panel.innerHTML;
      });
    } else {
      this.$el.innerHTML = text;
    }

    this.initElement();

    this.EMIT(this.CUSTOM_MESSAGES.NEWS_LIST_EVENTS.updateFilter, {
      container: this.$el
    });
  }
}
